/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.header__logo[_ngcontent-%COMP%]{min-width:calc(280px - 2rem)}}.header__logo[_ngcontent-%COMP%] > h1[_ngcontent-%COMP%]{line-height:100%;font-size:1.3rem;font-weight:400;margin:0}.header__logo[_ngcontent-%COMP%] > h1[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
